export const BrandLogo = ({ onClick, testId = "logo", className = "" }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`font-heading font-black leading-none inline-block ${className}`}
  >
    <span className="block text-[32px] tracking-tight">
      OTOROHANGA<span className="text-[#FF4F00]">.</span>
    </span>
    <span className="block text-[10px] tracking-[0.3em] text-zinc-400 font-bold text-center">
      HEALTH &amp; FITNESS
    </span>
  </button>
);
